import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14ece751"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-visible"]
const _hoisted_2 = { class: "mockup-shell" }
const _hoisted_3 = ["data-stage", "data-loaded"]
const _hoisted_4 = {
  class: "v3-artwork",
  "aria-hidden": "true"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "glass-benefit-panel",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "upgrade-sweep" }, null, -1 /* HOISTED */))
const _hoisted_8 = {
  key: 0,
  class: "upgrade-burst"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "power-lettering" }, [
  /*#__PURE__*/_createElementVNode("span", null, "POWER")
], -1 /* HOISTED */))
const _hoisted_10 = { class: "surge-lines" }
const _hoisted_11 = {
  key: 0,
  class: "tier-corner"
}
const _hoisted_12 = { class: "tier-corner-label" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "TOP", -1 /* HOISTED */))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "epic-light",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_15 = {
  class: "aura-particles",
  "aria-hidden": "true"
}
const _hoisted_16 = { class: "scene-content" }
const _hoisted_17 = { class: "benefit experience-benefit" }
const _hoisted_18 = { class: "gold-icon" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "benefit-label" }, "Therapist Experience", -1 /* HOISTED */))
const _hoisted_20 = ["data-range"]
const _hoisted_21 = { class: "gold-lettering" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "hr served", -1 /* HOISTED */))
const _hoisted_23 = { class: "benefits" }
const _hoisted_24 = ["aria-hidden"]
const _hoisted_25 = { class: "gold-icon" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("strong", { class: "gold-lettering" }, "VIP ROOM")
], -1 /* HOISTED */))
const _hoisted_27 = ["aria-hidden"]
const _hoisted_28 = { class: "gold-icon" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "benefit-label" }, "15mins MONEY BACK"),
  /*#__PURE__*/_createElementVNode("strong", { class: "money-back-word gold-lettering" }, "GUARANTEED")
], -1 /* HOISTED */))
const _hoisted_30 = ["aria-hidden"]
const _hoisted_31 = { class: "gold-icon" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("strong", { class: "gold-lettering" }, "Customize"),
  /*#__PURE__*/_createElementVNode("span", { class: "benefit-label" }, "Wellness Booster")
], -1 /* HOISTED */))
const _hoisted_33 = ["aria-hidden"]
const _hoisted_34 = { class: "gold-icon" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "benefit-label" }, "Disposable", -1 /* HOISTED */))
const _hoisted_36 = { class: "gold-lettering" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "×", -1 /* HOISTED */))
const _hoisted_38 = ["aria-hidden"]
const _hoisted_39 = { class: "gold-icon" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "benefit-label" }, "Disposable"),
  /*#__PURE__*/_createElementVNode("strong", { class: "gold-lettering" }, [
    /*#__PURE__*/_createTextVNode("SLIPPER "),
    /*#__PURE__*/_createElementVNode("small", null, "×"),
    /*#__PURE__*/_createTextVNode("1")
  ])
], -1 /* HOISTED */))
const _hoisted_41 = ["data-tier", "data-idle", "data-dragging", "data-powered", "data-turbo"]
const _hoisted_42 = {
  class: "bar-sparks",
  "aria-hidden": "true"
}
const _hoisted_43 = {
  id: "experience-label",
  class: "dynamic-experience-title",
  "aria-live": "polite"
}
const _hoisted_44 = ["data-tier"]
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Experience", -1 /* HOISTED */))
const _hoisted_46 = { class: "rail-area" }
const _hoisted_47 = {
  key: 1,
  class: "swipe-hint"
}
const _hoisted_48 = {
  class: "swipe-arrows",
  "aria-hidden": "true"
}
const _hoisted_49 = { class: "stage-stops" }
const _hoisted_50 = ["data-checkpoint", "aria-label", "aria-pressed", "onClick"]
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { "aria-hidden": "true" }, null, -1 /* HOISTED */))
const _hoisted_52 = [
  _hoisted_51
]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_BadgeCheck = _resolveComponent("BadgeCheck")
  const _component_Crown = _resolveComponent("Crown")
  const _component_ShieldCheck = _resolveComponent("ShieldCheck")
  const _component_Crosshair = _resolveComponent("Crosshair")
  const _component_Layers3 = _resolveComponent("Layers3")
  const _component_Footprints = _resolveComponent("Footprints")
  const _component_ExperienceSlider = _resolveComponent("ExperienceSlider")
  const _component_ChevronRight = _resolveComponent("ChevronRight")

  return (_openBlock(), _createElementBlock("div", {
    class: "mockup-page",
    "data-visible": $data.visible
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "experience-display",
        style: _normalizeStyle({ '--room-reveal': $options.roomReveal })
      }, [
        _createElementVNode("section", {
          class: "experience-scene",
          "data-stage": $options.tier,
          "data-loaded": $data.loaded,
          style: _normalizeStyle({ '--charge': $options.power, '--ultimate': $options.finalPower, '--room-reveal': $options.roomReveal, '--opening': $options.groupReveal, '--palette-shift': $options.ease(($data.progress - 65) / 13), '--upgrade-surge': Math.sin(Math.PI * $options.roomReveal) }),
          "aria-label": "Therapist transformation"
        }, [
          _createElementVNode("div", {
            class: "mobile-artwork-backdrop",
            "aria-hidden": "true",
            style: _normalizeStyle({ opacity: $options.poseOpacities[3] })
          }, null, 4 /* STYLE */),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.stages, (stage, index) => {
              return (_openBlock(), _createElementBlock("img", {
                key: stage.photo,
                class: _normalizeClass(index < 3 ? 'standard-artwork' : index === 3 ? 'room-artwork premium-room' : 'room-artwork'),
                src: stage.photo,
                alt: "",
                draggable: "false",
                style: _normalizeStyle({opacity:$options.poseOpacities[index]})
              }, null, 14 /* CLASS, STYLE, PROPS */, _hoisted_5))
            }), 128 /* KEYED_FRAGMENT */)),
            _createElementVNode("img", {
              class: "standard-artwork",
              src: "https://dr4y4dqumhrhn.cloudfront.net/frame-0.webp",
              alt: "",
              draggable: "false",
              style: _normalizeStyle({ opacity: $options.groupReveal })
            }, null, 4 /* STYLE */),
            _createElementVNode("div", {
              class: "premium-yellow-shade",
              style: _normalizeStyle({ opacity: $options.poseOpacities[3] })
            }, null, 4 /* STYLE */),
            _createElementVNode("div", {
              class: "reading-shade",
              style: _normalizeStyle({ opacity: $options.roomReveal })
            }, null, 4 /* STYLE */),
            _hoisted_6,
            _createElementVNode("div", {
              class: "ultimate-energy",
              style: _normalizeStyle({ opacity: $options.roomReveal })
            }, [
              _hoisted_7,
              ($options.tier === 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8))
                : _createCommentVNode("v-if", true),
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(16, (i) => {
                  return _createElementVNode("i", {
                    key: i,
                    style: _normalizeStyle($options.surgeStyle(i - 1))
                  }, null, 4 /* STYLE */)
                }), 64 /* STABLE_FRAGMENT */))
              ])
            ], 4 /* STYLE */),
            _createElementVNode("img", {
              class: "premium-portrait",
              src: "https://dr4y4dqumhrhn.cloudfront.net/premium-therapist.png",
              alt: "",
              draggable: "false",
              style: _normalizeStyle({ opacity: $options.poseOpacities[3] })
            }, null, 4 /* STYLE */),
            _createElementVNode("img", {
              class: "ultimate-portrait",
              src: "https://dr4y4dqumhrhn.cloudfront.net/ultimate-therapist-refined.png",
              alt: "",
              draggable: "false",
              style: _normalizeStyle({ opacity: $options.roomReveal })
            }, null, 4 /* STYLE */)
          ]),
          ($options.tier > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("b", null, _toDisplayString($options.tier === 2 ? '10%' : '20%'), 1 /* TEXT */)
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(14, (i) => {
              return _createElementVNode("i", {
                key: i,
                style: _normalizeStyle({'--i':i - 1})
              }, null, 4 /* STYLE */)
            }), 64 /* STABLE_FRAGMENT */))
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("span", _hoisted_18, [
                _createVNode(_component_BadgeCheck)
              ]),
              _createElementVNode("div", null, [
                _hoisted_19,
                _createElementVNode("div", {
                  class: "hours-line",
                  "data-range": $data.progress === 0
                }, [
                  _createElementVNode("strong", _hoisted_21, _toDisplayString($options.hoursLabel), 1 /* TEXT */),
                  _hoisted_22
                ], 8 /* PROPS */, _hoisted_20)
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", {
                class: "benefit final-benefit",
                style: _normalizeStyle({ '--reveal': $options.finalPower }),
                "aria-hidden": $options.finalPower < .05
              }, [
                _createElementVNode("span", _hoisted_25, [
                  _createVNode(_component_Crown)
                ]),
                _hoisted_26
              ], 12 /* STYLE, PROPS */, _hoisted_24),
              _createElementVNode("div", {
                class: "benefit money-back-benefit",
                style: _normalizeStyle({ '--reveal': $options.slippersPower }),
                "aria-hidden": $options.tier < 1
              }, [
                _createElementVNode("span", _hoisted_28, [
                  _createVNode(_component_ShieldCheck)
                ]),
                _hoisted_29
              ], 12 /* STYLE, PROPS */, _hoisted_27),
              _createElementVNode("div", {
                class: "benefit booster-benefit",
                style: _normalizeStyle({ '--reveal': $options.slippersPower }),
                "aria-hidden": $options.tier < 1
              }, [
                ($options.tier > 0)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("span", _hoisted_31, [
                        _createVNode(_component_Crosshair)
                      ]),
                      _hoisted_32
                    ], 64 /* STABLE_FRAGMENT */))
                  : _createCommentVNode("v-if", true)
              ], 12 /* STYLE, PROPS */, _hoisted_30),
              _createElementVNode("div", {
                class: "benefit towel-benefit",
                style: _normalizeStyle({ '--reveal': $options.slippersPower }),
                "aria-hidden": $options.tier < 1
              }, [
                _createElementVNode("span", _hoisted_34, [
                  _createVNode(_component_Layers3)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_35,
                  _createElementVNode("strong", _hoisted_36, [
                    _createTextVNode("TOWEL "),
                    _hoisted_37,
                    _createTextVNode(_toDisplayString($options.tier === 2 ? 3 : 1), 1 /* TEXT */)
                  ])
                ])
              ], 12 /* STYLE, PROPS */, _hoisted_33),
              _createElementVNode("div", {
                class: "benefit slipper-benefit",
                style: _normalizeStyle({ '--reveal': $options.slippersPower }),
                "aria-hidden": $options.tier < 1
              }, [
                _createElementVNode("span", _hoisted_39, [
                  _createVNode(_component_Footprints)
                ]),
                _hoisted_40
              ], 12 /* STYLE, PROPS */, _hoisted_38)
            ])
          ]),
          _createCommentVNode(" <div class=\"bank-promo\" :data-visible=\"tier > 0\" :aria-hidden=\"tier === 0\">\n                        <img src=\"https://dr4y4dqumhrhn.cloudfront.net/public-bank-logo.png\" alt=\"Public Bank\" draggable=\"false\" />\n                        <span>Special Promo</span>\n                    </div> ")
        ], 12 /* STYLE, PROPS */, _hoisted_3),
        _createElementVNode("section", {
          class: "experience-bar",
          "data-tier": $options.tier,
          "data-idle": $data.target === 0 && !$data.dragging && $data.progress < .1,
          "data-dragging": $data.dragging,
          "data-powered": $data.dragging || $data.target >= $data.powerCheckpoint || $data.progress >= $data.powerCheckpoint,
          "data-turbo": $options.sliderValue === 100,
          style: _normalizeStyle({ '--fill': `${$options.sliderValue}%`, '--standard-offset': `${-25 * (1 - Math.min($options.sliderValue / $data.powerCheckpoint, 1))}px` })
        }, [
          _createElementVNode("div", _hoisted_42, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(($options.sliderValue === 100 ? 48 : 16), (i) => {
              return (_openBlock(), _createElementBlock("i", {
                key: i,
                style: _normalizeStyle($options.sparkStyle(i - 1))
              }, null, 4 /* STYLE */))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _createElementVNode("h2", _hoisted_43, [
            _createElementVNode("span", {
              class: "bar-tier-name",
              "data-tier": $options.tier
            }, [
              _createElementVNode("span", null, _toDisplayString($options.tier === 0 ? 'Standard' : $options.tier === 1 ? 'DELUXE' : 'ULTRA'), 1 /* TEXT */)
            ], 8 /* PROPS */, _hoisted_44),
            _hoisted_45
          ]),
          _createElementVNode("div", _hoisted_46, [
            _createVNode(_component_ExperienceSlider, {
              value: $options.sliderValue,
              "value-text": `${$options.targetExperience.label} hours served`,
              onChange: $options.onSliderChange,
              onCommit: $options.release,
              onCancel: $options.cancelDrag,
              onNavigate: $options.navigateCheckpoint
            }, null, 8 /* PROPS */, ["value", "value-text", "onChange", "onCommit", "onCancel", "onNavigate"]),
            (!$data.dragging && $options.tier > 0 && Math.abs($data.progress - $data.target) < .1)
              ? (_openBlock(), _createElementBlock("span", {
                  class: "tier-tagline",
                  key: $options.tier,
                  style: _normalizeStyle({ '--tagline-progress': $options.sliderValue / 100 })
                }, _toDisplayString($options.tier === 2 ? 'The perfect blend of privacy and mastery.' : 'The upgraded break you deserve.'), 5 /* TEXT, STYLE */))
              : _createCommentVNode("v-if", true),
            ($data.target === 0 && !$data.dragging)
              ? (_openBlock(), _createElementBlock("span", _hoisted_47, [
                  _createElementVNode("span", _hoisted_48, [
                    _createVNode(_component_ChevronRight),
                    _createVNode(_component_ChevronRight)
                  ]),
                  _createCommentVNode(" <span class=\"swipe-copy\">Swipe for Public Bank<br />Special Offer</span> ")
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_49, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.checkpoints, (checkpoint) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: checkpoint.value,
                  "data-checkpoint": checkpoint.value,
                  style: _normalizeStyle({left:`${checkpoint.value}%`}),
                  "aria-label": `${checkpoint.label} hours checkpoint`,
                  "aria-pressed": $data.target === checkpoint.value,
                  onPointerdown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
                  onClick: $event => ($options.commit(checkpoint.value))
                }, [..._hoisted_52], 44 /* STYLE, PROPS, NEED_HYDRATION */, _hoisted_50))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ])
        ], 12 /* STYLE, PROPS */, _hoisted_41)
      ], 4 /* STYLE */)
    ])
  ], 8 /* PROPS */, _hoisted_1))
}